export const Types = {
  SET_USER: 'auth/SET_USER',
  LOG_IN: 'auth/LOG_IN',
  SIGN_OUT: 'auth/SIGN_OUT',
  LOG_OUT: 'auth/LOG_OUT',
  SET_COMPANY: 'auth/SET_COMPANY',
  DEF_PASSWORD: 'auth/SET_PASSWORD'
}

const initialState = {
  account: {},
  isLogged: false
}

export default function auth(state = initialState, action) {
  switch (action.type) {
    case Types.SET_USER:
      return {
        ...state,
        ...action.user,
        isLogged: true
      }
    case Types.DEF_PASSWORD:
      return {
        ...state,
        account: {
          ...state.account,
          user: {
            ...state.account.user,
            requestPasswordChange: false
          }
        }
      }
    case Types.SET_COMPANY:
      return {
        ...state,
        account: {
          ...state.account,
          company: action.company
        }
      }
    case Types.LOG_OUT:
      return initialState
    default:
      return state
  }
}


export const defPassword = () => {
  return {
    type: Types.DEF_PASSWORD
  }
}

export const setCompany = (company) => ({
  type: Types.SET_COMPANY,
  company
})

export const handleLogout = () => ({ type: Types.SIGN_OUT })

export const handleLogin = (user) => {
  return {
    type: Types.LOG_IN,
    user
  }
}